import TCFConsentRow from './TCFConsentRow'

export default TCFConsentRow
